import { Modal } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ItemType, MappingItemIdIndexType } from '../types';

const useCheckCycleLink = (isShowMessage: boolean = true) => {
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);

    return (itemDrag: ItemType, itemDrop: ItemType) => {
        if (itemDrag.parentId === itemDrop.id) {
            if (isShowMessage) {
                if (itemDrop.id === itemDrag.parentId) {
                    Modal.error({
                        title: 'Error nesting items',
                        content: `Item "${itemDrop.name}" can't be nested in himself`,
                    });
                } else {
                    Modal.warning({
                        title: 'Warning nesting items',
                        content: `Item "${itemDrop.name}" already include item "${itemDrag.name}"`,
                    });
                }
            }
            return false;
        }

        const nestingLink: string[] = [
            itemsList[mappingItemIdIndex[itemDrag.id]].name,
            itemsList[mappingItemIdIndex[itemDrop.id]].name,
        ];

        const checkCycle = (parentId?: string | null): boolean => {
            if (parentId) {
                const itemParent = itemsList[mappingItemIdIndex[parentId]];
                nestingLink.push(itemsList[mappingItemIdIndex[itemParent.id]].name);
                if (parentId === itemDrag.id) {
                    return true;
                }
                return checkCycle(itemsList[mappingItemIdIndex[parentId]].parentId);
            }
            return false;
        };

        if (checkCycle(itemDrop.parentId)) {
            if (isShowMessage) {
                Modal.error({
                    title: 'Error cycle nesting items',
                    content: (
                        <div>
                            <span>{`Item "${itemDrag.name}" can't be nesting to "${itemDrop.name}"`}</span>
                            <br />
                            <span>{`Cycle links:`}</span>
                            <br />
                            <span>{nestingLink.map((link) => `"${link}"`).join(' -> ')}</span>
                        </div>
                    ),
                });
            }
            return false;
        }

        return true;
    };
};

export default useCheckCycleLink;
